import { render, staticRenderFns } from "./DataListQuestions.vue?vue&type=template&id=eb22f194&scoped=true&"
import script from "./DataListQuestions.vue?vue&type=script&lang=js&"
export * from "./DataListQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DataListQuestions.vue?vue&type=style&index=0&id=eb22f194&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb22f194",
  null
  
)

export default component.exports